/**
 * 激活码相关 API
 * 仅负责请求与结果解析，不写 localStorage
 */
import request from './request'

/**
 * 使用激活码（调用服务端「使用」接口）
 * @param {string} code 激活码
 * @returns {Promise<{ success: boolean, message?: string }>}
 */
export function useActivationCode(code) {
  const trimmed = typeof code === 'string' ? code.trim() : ''
  if (!trimmed) {
    return Promise.reject(new Error('请输入激活码'))
  }

  return request
    .post('v1/api/activation-codes/use', { code: trimmed })
    .then((res) => {
      if (res && res.code === 200) {
        return { success: true }
      }
      const message = (res && res.message) || '激活失败，请稍后重试'
      return { success: false, message }
    })
    .catch((err) => {
      const message = err && err.message ? err.message : '网络异常，请稍后重试'
      return Promise.reject(new Error(message))
    })
}
